import type { ComponentProps } from 'react';
import { Splitter } from '@terra/ui-design-system';

const horizontalResizeTriggerProps = {
  width: '1px',
  minWidth: '1px',
  margin: '0',
  bg: 'transparent',
  position: 'relative' as const,
  cursor: 'col-resize',
  zIndex: 10,
  _after: {
    content: '""',
    position: 'absolute',
    inset: '0 -6px 0 -6px',
    width: '13px',
    bg: 'transparent',
    cursor: 'col-resize',
    zIndex: 10,
  },
};

type LayoutSplitterResizeTriggerProps = Pick<
  ComponentProps<typeof Splitter.ResizeTrigger>,
  'id'
>;

export function LayoutSplitterResizeTrigger({
  id,
}: LayoutSplitterResizeTriggerProps) {
  return <Splitter.ResizeTrigger id={id} {...horizontalResizeTriggerProps} />;
}
